/** Domain changes do not change storage keys or recreate rooms. */
export const CANONICAL_ORIGIN = 'https://slides.v1d.io';
export const PREVIOUS_ORIGIN = 'https://slides2.v1d.io';
export const ARCHIVE_ORIGIN = 'https://slides-v1d.pages.dev';
export const ARCHIVED_DECKS = [
  {id: 'kurs2', title: 'Kurs 2'},
  {id: 'fel', title: 'Felfunktioner'},
];

export function legacyDestination(url: URL): string | null {
  const destination = new URL(url);
  const deck = url.searchParams.get('deck');
  const mode = /^\/(edit|present|speaker)(?:\.html)?\/?$/.exec(url.pathname)?.[1];
  if (mode && ARCHIVED_DECKS.some(item => item.id === deck)) {
    // The archive retains its own assets and renderer.
    return `${ARCHIVE_ORIGIN}/${mode}.html${url.search}${url.hash}`;
  }
  if (mode && (url.pathname.endsWith('.html') || deck === 'kurs4-preview')) {
    destination.pathname = `/${mode}`;
    if (deck === 'kurs4-preview') destination.searchParams.set('deck', 'kurs4');
    return destination.href;
  }
  if (url.pathname.startsWith('/slidemark-')) return `${ARCHIVE_ORIGIN}${url.pathname}${url.search}${url.hash}`;
  return null;
}
